/* eslint-disable */
require('./apple')
require('./beer_bottles')
require('./beer')
require('./burger_and_cola')
require('./chicken_legs')
require('./coffee')
require('./cubata')
require('./cup')
require('./cupcake_in_hand')
require('./desserts')
require('./euro_symbol')
require('./french_fries')
require('./hamburger')
require('./ice_cream_with_chopsticks')
require('./juice')
require('./new_hot_dog')
require('./noodles')
require('./paella')
require('./paper_crossed')
require('./patties')
require('./piece_of_pizza')
require('./pineapple_cocktail')
require('./pizza_in_a_box')
require('./sad_face')
require('./sandwich')
require('./shirt')
require('./snaks')
require('./sushi')
require('./star')
require('./taco')
require('./tag')
require('./water')
require('./wine_bottle')
require('./receive_cash')
